import React from 'react';
import { observer } from 'mobx-react';
import { RatingTypeStore } from '@seedlang/stores';
import InPlaceText from 'components/form/in_place_text';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import Stack from 'components/layout/stack';
import Grid from 'components/layout/grid';

@observer
class RatingTypeEdit extends React.Component {

  componentDidMount() {
    RatingTypeStore.getShow({ ids: {ratingTypeId: this.props.params.ratingTypeId }});
  }

  render() {
    return (
      <Stack gap='sm' alignItems='stretch'>
        <Grid columns={3}>
          <InPlaceText
            legend='Name'
            defaultValue={RatingTypeStore.showDataField('name')}
            model='rating_types'
            field='name'
            id={RatingTypeStore.showDataField('id')}
          />
          <InPlaceText
            legend='Slug'
            defaultValue={RatingTypeStore.showDataField('slug')}
            model='rating_types'
            field='slug'
            id={RatingTypeStore.showDataField('id')}
          />
          <InPlaceCheckbox
            legend='Overall'
            value={RatingTypeStore.showDataField('overall')}
            model='rating_types'
            field='overall'
            id={RatingTypeStore.showDataField('id')}
          />
        </Grid>
        <InPlaceText
          legend='Description'
          defaultValue={RatingTypeStore.showDataField('description')}
          model='rating_types'
          field='description'
          id={RatingTypeStore.showDataField('id')}
        />
      </Stack>
    );
  }
}

export default RatingTypeEdit;
